/* «К проекту» — возврат на страницу проекта в витрине AIP. Если страница
   открыта из витрины (есть window.opener), фокусируем исходную вкладку и
   закрываем эту; при прямом заходе — обычный переход. Кнопка, а не
   <a href>: у ссылки браузер показывает URL в статус-бабле (левый нижний
   угол), владелец попросил этого не делать. */
const PROJECT_HREF = 'https://ai.alex-n8n.site/cases/ai-curator.html';

export function goProject() {
  try {
    if (window.opener && !window.opener.closed) {
      window.opener.focus();
      window.close();
      return;
    }
  } catch {
    /* opener недоступен — обычный переход */
  }
  window.location.href = PROJECT_HREF;
}

function ProjectReturnButton({ className = '' }) {
  return (
    <button
      type="button"
      onClick={goProject}
      title="Вернуться на страницу проекта в витрине AIP."
      aria-label="К проекту"
      className={`flex h-9 w-9 shrink-0 items-center justify-center rounded-ai text-base text-ai-text-muted transition hover:bg-ai-surface-hover hover:text-ai-text ${className}`}
    >
      ↩
    </button>
  );
}

export default ProjectReturnButton;